<template>
    <div class="main">
        <detailBox :title="titleOne">
            <div class="slotOne">
                <Button type="primary" ghost>查看投保详情</Button>
            </div>
        </detailBox>
        <detailBox :title="titleTwo">
            <div class="slotOne">
                <Form :model="policy" :label-width="100">
                    <Row>
                        <Col span="12">
                        <Form-item label="保险名称：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                        <Col span="12">
                        <Form-item label="保险单号：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                        <Col span="24">
                        <Form-item label="保险公司：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                        <Col span="24">
                        <Form-item label="被保险人：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                        <Col span="24">
                        <Form-item label="变更事项：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                        <Col span="24">
                        <Form-item label="变更原因：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                        <Col span="24">
                        <Form-item label="延期结束日期：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                        <Col span="24">
                        <Form-item label="上传附件：">
                            {{policy.name}}
                        </Form-item>
                        </Col>
                    </Row>
                </Form>
            </div>
        </detailBox>

    </div>
</template>
<script>
    import detailBox from '../common/detailBox.vue'

    export default {
        components: { detailBox },
        data () {
            return {
                titleOne: '投保情况',
                titleTwo: '批改单明细',

                policy: {},


            }
        },
        methods: {
            handelDet () { },
        },
    }
</script>
<style scoped>
    .main {
        padding: 24px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/correctionDet.vue